module.exports = __webpack_public_path__ + "static/mutantgarden-bdface870d55ee99fe852db324da3d3d.png";